import { HttpClient, HttpEventType } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var BulkUploadService = /** @class */ (function () {
    function BulkUploadService(http) {
        this.http = http;
    }
    BulkUploadService.prototype.upload = function (data) {
        return this.http.post('dealers/report/upload/', data, {
            reportProgress: true,
            observe: 'events'
        }).pipe(map(function (event) {
            switch (event.type) {
                // We do assume here, that uploading the file takes around 20% of the total processing time
                case HttpEventType.UploadProgress: {
                    var progress = Math.round(20 * event.loaded / event.total);
                    return { finished: false, processing: true, progress: progress };
                }
                case HttpEventType.Response: {
                    var progress = Math.round(20 + 0.8 * event.body.progress);
                    return {
                        errors: event.body.errors,
                        finished: event.body.finished,
                        processing: !event.body.finished,
                        progress: progress,
                        uploadId: event.body.uploadId
                    };
                }
                default:
                    return null;
            }
        }));
    };
    BulkUploadService.prototype.checkStatus = function (uploadId) {
        return this.http.get("dealers/report/upload/" + uploadId + "/")
            .pipe(map(function (response) {
            return {
                errors: response.errors,
                finished: response.finished,
                processing: !response.finished,
                progress: Math.round(20 + 0.8 * response.progress),
                uploadId: response.finished ? '' : response.uploadId
            };
        }));
    };
    BulkUploadService.ngInjectableDef = i0.defineInjectable({ factory: function BulkUploadService_Factory() { return new BulkUploadService(i0.inject(i1.HttpClient)); }, token: BulkUploadService, providedIn: "root" });
    return BulkUploadService;
}());
export { BulkUploadService };
